/** Pull the draft body out of accumulated tool-input JSON. Never returns raw JSON. */
export const extractStreamingDraftBody = (
  partialJson: string | undefined,
  bodyKey: string
): string => {
  if (!partialJson) return '';
  const trimmed = partialJson.trim();
  if (!trimmed) return '';

  try {
    const parsed: unknown = JSON.parse(trimmed);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      const value = (parsed as Record<string, unknown>)[bodyKey];
      return typeof value === 'string' ? value : '';
    }
  } catch {
    // Incomplete JSON — fall through to the field extractor.
  }

  return extractPartialJsonStringField(trimmed, bodyKey);
};

const extractPartialJsonStringField = (text: string, key: string): string => {
  const keyPattern = new RegExp(String.raw`"${escapeRegExp(key)}"\s*:`);
  const match = keyPattern.exec(text);
  if (!match) return '';
  const rest = text.slice(match.index + match[0].length).trimStart();
  if (!rest.startsWith('"')) return '';
  return unescapePartialJsonString(rest.slice(1));
};

const escapeRegExp = (value: string): string =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const unescapePartialJsonString = (raw: string): string => {
  let out = '';
  for (let index = 0; index < raw.length; index += 1) {
    const char = raw[index];
    if (char === '"') break;
    if (char === '\\' && index + 1 < raw.length) {
      const next = raw[index + 1];
      if (next === 'n') out += '\n';
      else if (next === 't') out += '\t';
      else if (next === 'r') out += '\r';
      else if (next === '"' || next === '\\' || next === '/') out += next;
      else if (next === 'u') {
        const hex = raw.slice(index + 2, index + 6);
        if (hex.length < 4 || !/^[0-9a-fA-F]{4}$/.test(hex)) break;
        out += String.fromCodePoint(Number.parseInt(hex, 16));
        index += 5;
        continue;
      } else out += next;
      index += 1;
      continue;
    }
    out += char;
  }
  return out;
};
